<template>
	<div>
		<el-container>
			<el-aside width="250px" :style="{'height': tableHeight+200 + 'px', 'border': '1px solid #ccc'}">
				<LocationTree ref="orangeRef" @addRoom="addRoom" @addNode="addHandle" @getTreeData="locationTreeNodeClick" @editNode="editHandle" @deleteNode="delHandle"/>
			</el-aside>
			<!-- <button @click="xinzeng">xinzeng</button> -->
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="房间号" property="roomNo">
									<el-input
										v-model="searchForm.roomNo"
										placeholder="输入房间号"
										clearable
										@keyup.enter.native="getLocationMachineList"
									>
									</el-input>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
								<el-button size="mini" type="primary" @click.native.prevent="getLocationMachineList">查 询</el-button>
								<el-button size="mini" @click="resetSearchForm">重 置</el-button>
							</div>
						</el-form>
					</div>
					<hr class="search_border">
					<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools" style="display: flex;">
							<el-button style="margin-left: 10px;" type="primary" slot="reference" @click="exportList" >导出</el-button>
						</div>
					</div>
					<el-table
						v-loading='loading'
						ref="multipleTable"
						:data="tableData"
						tooltip-effect="dark"
						:height="tableHeight"
						border
						stripe
						@selection-change="handleSelectionChange"
					>
						<el-table-column type="index" label="序号" align="center" width="80"> </el-table-column>
						<el-table-column prop="locationFullName" label="房间名称" show-overflow-tooltip align="center">
							<template slot-scope="scope">
								{{ scope.row.buildingName }}-{{ scope.row.roomNo }}
								<!-- {{ scope.row.regionName }}/{{ scope.row.buildingName }}/{{ scope.row.roomNo }} -->
							</template>
						</el-table-column>
						<el-table-column prop="personCount" label="床位数" width="80" align="center"></el-table-column>
						<el-table-column prop="sexFlag" label="性别" width="80" align="center">
							<template slot-scope="scope">
								{{ scope.row.sexFlag == 0 ? '女' : '男' }}
							</template>
						</el-table-column>
						<el-table-column prop="accBalance" label="房间余额（元）" show-overflow-tooltip align="center">
							<template slot-scope="scope">
								{{ scope.row.accBalance ? parseFloat(scope.row.accBalance).toFixed(4) : 0 }}
							</template>
						</el-table-column>
						<el-table-column prop="quotaBalance" label="配额余额（度）" show-overflow-tooltip align="center"></el-table-column>
						<!-- <el-table-column prop="quotaName" label="配额名称" align="center" show-overflow-tooltip></el-table-column> -->
						<!-- <el-table-column prop="priceName" label="单价名称" align="center" show-overflow-tooltip></el-table-column> -->
						<el-table-column prop="icon" label="操作" fixed="right" width="100px" align="center">
							<template slot-scope="scope">

								<!-- <el-button type="text" v-if="hasAuth('room:quota:recharge')" @click="faButie(scope.row)" title="发放/扣除 补贴及余额">发扣补贴</el-button>
								<el-divider direction="vertical" v-if="hasAuth('room:quota:recharge')"></el-divider>  -->

								<!-- <el-dropdown @command="viewHandle">
									<span class="el-dropdown-link" style="cursor: pointer;">更多</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item :command="{'row': scope.row, 'rowType': 'peo'}" >入住人员</el-dropdown-item>
										<el-dropdown-item :command="{'row': scope.row, 'rowType': 'ele'}" >用电明细</el-dropdown-item>
										<el-dropdown-item :command="{'row': scope.row, 'rowType': 'mon'}" >交易明细</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown> -->

								<!-- <el-button type="text" @click="viewHandle({scope.row, 'peo'})">入住人员</el-button>
								<el-divider direction="vertical"></el-divider>
								<el-button type="text" @click="viewHandle({scope.row, 'ele'})">用电明细</el-button>
								<el-divider direction="vertical"></el-divider>
								<el-button type="text" @click="viewHandle({scope.row, 'mon'})">交易明细</el-button> -->
							</template>
						</el-table-column>
					</el-table>
					<el-pagination
						style="text-align: right;"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						layout="total, sizes, prev, pager, next, jumper"
						:page-sizes="[10, 20, 50, 100]"
						:current-page="current"
						:page-size="size"
						:total="total">
					</el-pagination>

				</el-main>
			</el-container>
		</el-container>

		<!--补贴发放对话框-->
		<el-dialog
		  :title="bu.dialogTitle"
		  :visible.sync="bu.dialogVisible"
		  width="600px"
		  :before-close="buhandleClose"
		  :close-on-click-modal="false">

			<el-form :model="bu.editForm" :rules="bu.editFormRules" ref="bueditForm" label-width="100px" class="demo-editForm">

				<el-form-item label="操作类型" prop="lx" label-width="100px">
					<el-radio-group v-model="bu.editForm.lx">
						<el-radio :label="0">发放</el-radio>
						<el-radio :label="1">扣除</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="操作对象" prop="type" label-width="100px">
					<el-radio-group v-model="bu.editForm.type">
						<el-radio :label="0">配额（度）</el-radio>
						<el-radio :label="1">房间余额（元）</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="补贴额度" prop="payQuota" label-width="100px">
					<el-input type="number" v-model="bu.editForm.payQuota" placeholder="请输入补贴额度" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注：" prop="remark" label-width="100px">
					<el-input v-model="bu.editForm.remark" placeholder="请填写备注" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="buresetForm">取 消</el-button>
				<el-button type="primary" @click="busubmitForm">确 定</el-button>
			</div>
		</el-dialog>

		<!--新增对话框-->
		<el-dialog
		  :title="dialogTitle"
		  :visible.sync="dialogVisible"
		  width="600px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">
				<!-- <el-form-item label="绑定设备：" prop="machineId" label-width="100px">
					<el-select v-model="editForm.machineId" placeholder="请选择设备">
						<el-option v-for="machineInfo in machineData"
								   :label="machineInfo.machineNum + '|' + machineInfo.shortName"
								   :value="machineInfo.id"
								   :key="machineInfo.id">
						</el-option>
					</el-select>
				</el-form-item> -->

				<el-form-item v-if="dialogType == 'ld'" label="楼栋名称：" prop="locationName" label-width="100px">
					<el-input v-model="editForm.locationName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogType == 'ld'" label="同级排序：" prop="orderNum" label-width="100px">
					<el-input type="number" v-model="editForm.orderNum" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogType == 'rm'" label="房间名称：" prop="roomNo" label-width="100px">
					<el-input v-model="editForm.roomNo" placeholder="请输入房间名称(例：101)" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogType == 'rm'" label="性别：" prop="sexFlag" label-width="100px">
					<el-select v-model="editForm.sexFlag" placeholder="请选择性别">
						<el-option label="女" value="0"></el-option>
						<el-option label="男" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="dialogType == 'rm'" label="床位数：" prop="personCount" label-width="100px">
					<el-input type="number"  v-model="editForm.personCount" placeholder="请输入床位数" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogType == 'rm'" label="配额：" prop="quotaName" label-width="100px">
					<el-select v-model="editForm.quotaName" placeholder="请选择配额">
						<el-option v-for="item in quotaList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="dialogType == 'rm'" label="单价：" prop="priceName" label-width="100px">
					<el-select v-model="editForm.priceName" placeholder="请选择单价">
						<el-option v-for="item in priceList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 查看入住人员、交易记录 -->
		<el-dialog
		  :title="dialog.title"
		  :visible.sync="dialog.dialogVisible"
		  width="800px"
		  
		  top="10vh"
		  :before-close="handleCloseDialog"
		>
			<el-form v-if="dialog.getParams.type != 'peo'" class="form-main" size="mini" inline label-width="80px" label-position="right">
				<span>
					<el-form-item label="日期范围" property="dateRange">
						<span>
							<el-date-picker
								v-model="dialog.dateRange"
								type="daterange"
								align="right"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								:picker-options="pickerOptions"
								@change="viewHandle"
							/>
						</span>
					</el-form-item>
				</span>
				<div class="search-box-button search-button search_box_button_right">
					<el-button size="mini" type="primary" @click.native.prevent="viewHandle">查 询</el-button>
				</div>
			</el-form>
		  	<el-table
				ref="dialogTable"
				:data="dialog.tableData"
				tooltip-effect="dark"
				border
				stripe
				>
				<!-- size="small" -->
				<el-table-column prop="index" type="index" label="序号" align="center" width="60"></el-table-column>
				<el-table-column v-for="(column,i) in sortedColumns" :key="i" :label="column.label" :prop="column.prop" show-overflow-tooltip v-if="column.visible">
				</el-table-column>
				<el-table-column v-if="dialog.getParams.type == 'peo'" prop="personFlag" label="类型" align="center">
					<template slot-scope="scope">
						<el-tag type="primary" v-if="scope.row.personFlag == 1">缴费代表</el-tag>
						<el-tag type="success" v-if="scope.row.personFlag == 0">成员</el-tag>
					</template>
				</el-table-column>
				<el-table-column v-if="dialog.getParams.type == 'peo'" label="操作" align="center">
					<template slot-scope="scope">
						<el-button style="color: orange" v-if="scope.row.personFlag && hasAuth('room:person:mgTransfer')" type="text" @click="zhuanyi(scope.row)" title="转移宿舍代表">转移</el-button>
						<span v-else style="margin-left: 10px;">
							<el-popconfirm v-if="hasAuth('room:person:unbind')" title="确定解绑该学生的宿舍信息吗？" @confirm="jieHandle(scope.row)">
								<el-button style="color: red" type="text" slot="reference">解绑</el-button>
							</el-popconfirm>
						</span>
					</template>
				</el-table-column>
				<!-- <span v-if="dialog.getParams.type == 'peo'">
					<el-table-column v-if="dialog.getParams.type == 'peo'"  prop="lastBalance" label="个人余额（元）" align="center">
						<template slot-scope="scope">
							{{ scope.row.lastBalance ? parseFloat(scope.row.lastBalance).toFixed(4) : 0 }}
						</template>
					</el-table-column>
					<el-table-column v-if="dialog.getParams.type == 'peo'" prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
					<el-table-column v-if="dialog.getParams.type == 'peo'"  prop="personName" label="姓名" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column v-if="dialog.getParams.type == 'peo'"  prop="personNo" label="学号" align="center"></el-table-column>
					<el-table-column v-if="dialog.getParams.type == 'peo'"  prop="identityName" label="类型" align="center"></el-table-column>
				</span>
			
				<span v-if="dialog.getParams.type == 'mon'">
					<el-table-column prop="outBalance" label="交易后配额" align="center"></el-table-column>
					<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
					<el-table-column prop="dealName" label="交易类型" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="inBalance" label="交易前配额" align="center"></el-table-column>
					<el-table-column prop="dealAmount" label="交易配额" align="center"></el-table-column>
				</span>

				<span v-if="dialog.getParams.type == 'ele'">
					<el-table-column prop="recordDate" label="读表时间" width="200" align="center"></el-table-column>
					<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
					<el-table-column prop="elecNo" label="表号" align="center"></el-table-column>
					<el-table-column prop="inAmount" label="起码" align="center"></el-table-column>
					<el-table-column prop="outAmount" label="止码" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="thisAmount" label="用电量" align="center"></el-table-column>
				</span> -->
			</el-table>

			<el-pagination
				@size-change="handleSizeChangeDialog"
				@current-change="handleCurrentChangeDialog"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="dialog.current"
				:page-size="dialog.size"
				:total="dialog.total">
			</el-pagination>
			<div slot="footer" class="dialog-footer" style="margin-top: 20px;text-align: center;">
				<el-button @click="handleCloseDialog">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import { getTree, getRoomListHis, getPersonList, getMomentList, clearPe, addLd, updateLd, delLd, addRoom, updateRoom, addButie, delButie, addYe, delYe } from '@/apis/orange'
import {  updateJiaofei, jiebangPeo } from '@/apis/student'

import { getApi } from '@/apis/peie'
import { getDj } from '@/apis/electric'
import { getDevice, getDeviceRecord, importDevice } from '../../apis/devices.js'
import LocationTree from "../base/LocationTree.vue";
import { mapActions } from 'vuex'

export default {
	name: "Orange",
	components: { LocationTree },
	data() {
		return {
			loading: false,
			nowDate: '',
			searchForm: {
				roomNo: ""
			},
			columns: [
				{ order: 1, label: '姓名', prop: 'personName', visible: true },
				{ order: 2, label: '学号', prop: 'personNo', visible: true },
				{ order: 3, label: '入住日期', prop: 'inDate', visible: true },

				{ order: 4, label: '交易类型', prop: 'dealName', visible: false },
				{ order: 5, label: '账户', prop: 'walletName', visible: false },
				{ order: 6, label: '交易前', prop: 'inBalance', visible: false },
				{ order: 7, label: '交易值', prop: 'dealAmount', visible: false },
				{ order: 13, label: '交易后', prop: 'outBalance', visible: false },
				{ order: 14, label: '交易时间', prop: 'createTime', visible: false },

				{ order: 8, label: '表号', prop: 'elecNo', visible: false },
				{ order: 9, label: '起码', prop: 'inAmount', visible: false },
				{ order: 10, label: '止码', prop: 'outAmount', visible: false },
				{ order: 11, label: '用电量', prop: 'thisAmount', visible: false },
				{ order: 12, label: '读表时间', prop: 'recordDate', visible: false },
			],
			delBtlStatu: true,
			clickNode: {},		// 点击某个树的数据
			clearTitle: '确定批量清空房间配额吗',

			total: 0,
			size: 10,
			current: 1,

			bu: {
				dialogTitle: '补贴发放',
				dialogVisible: false,
				editForm: {},
				editFormRules: {
					lx: [
						{required: true, message: '请选择类型', trigger: 'change'}
					],
					type: [
						{required: true, message: '请选择操作对象', trigger: 'change'}
					],
					payQuota: [
						{required: true, message: '请输入补贴额度', trigger: 'blur'}
						// { validator: this.validateNonZeroNumber, trigger: 'blur' }
					],
					remark: [
						{required: true, message: '请填写备注', trigger: 'blur'}
					]
				}
			},

			quotaList: [],
			priceList: [],
			dialogType: 'ld',	// ld: 楼栋, rm: 房间
			dialogTitle: '新增楼栋',
			dialogVisible: false,
			parentObj: {},
			editForm: {},
			editFormRules: {
				locationName: [
					{required: true, message: '请输入楼栋名称', trigger: 'blur'}
				],
				roomNo: [
					{required: true, message: '请输入房间名称', trigger: 'blur'}
				],
				sexFlag: [
					{required: true, message: '请选择性别', trigger: 'change'}
				],
				personCount: [
					{required: true, message: '请输入床位数', trigger: 'blur'}
				],
				// orderNum: [
				// 	{required: true, message: '请输入同级排序', trigger: 'blur'}
				// ]
			},

			tableData: [],
			machineData: [],
			multipleSelection: [],

			dialog: {
				total: 0,
				size: 10,
				current: 1,

				title: '',
				dialogVisible: false,
				getParams: {},
				dateRange: [],
				tableData: [],
			},

			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		},
		sortedColumns() {
			return this.columns.filter(col => col.visible).sort((a, b) => {
			// 根据需要自定义排序逻辑，例如按照某个属性或固定顺序排序
			return a.order - b.order; // 假设每个列都有一个order属性来定义显示顺序
			});
		}
	},
	mounted() {
		let t = new Date()
		let endDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2)
		this.nowDate = endDate
		// this.getlocationtotal(1);
		this.getQuotaList()
	},
	methods: {
		...mapActions('treeData', ['refreshTreeData']),
		
		// 通知更新树形数据
		async notifyTreeDataUpdate() {
			try {
				await this.refreshTreeData()
				this.$message({
					showClose: true,
					message: '数据已更新',
					type: 'success',
				})
			} catch (error) {
				console.error('更新树形数据失败:', error)
				this.$message({
					showClose: true,
					message: '更新数据失败',
					type: 'error',
				})
			}
		},

		heZhaHandle(row, type) {
			const loading = this.$loading({
				text: '处理中...',
			});
			
			getDevice({current: 1, size: 10, buildingName: row.buildingName, roomNo: row.roomNo}).then(res => res.data).then(res => {
				let tableData = res.data.records
				if (tableData && tableData.length) {
					tableData.map(it => {
						fetch('/lazha/my_endpoint', {
							method: 'post',
							body: JSON.stringify({
								param1: 'd5404bc8939b7e0dd162e8171e276c0d',
								param2: it.elecNo,
								param3: type
							}),
							headers: {
								'Content-Type': 'application/json'
							}
						}).then(response => response.json())
						.then(data => {
							loading.close();
							
							this.$message({
								showClose: true,
								message: data.zhuangtai === 'ok' ? '操作成功' : '操作失败,请再试一次',
								type: data.zhuangtai === 'ok' ? 'success' : 'error',
								duration: 3000,
							});
						}).catch(error => {
							loading.close();
							
							this.$message({
								showClose: true,
								message: '操作失败',
								type: 'error',
							});
						});
					})
				} else {
					loading.close();
				}
				
			})
		},
		
		getQuotaList() {
			getApi({
				current: this.current,
				size: this.size,
			}).then(res => res.data).then(res => {
				this.quotaList = res.data.records.map(item => ({
					label: `${item.quotaName}（每床位：${item.quota}度，生效日期：${item.startDate}）`,
					value: item.quotaName
				}))
			})
			getDj({
				current: this.current,
				size: this.size,
			}).then(res => res.data).then(res => {
				this.priceList = res.data.records.map(item => ({
					label: `${item.priceName}（单价：${item.price}元，生效日期：${item.startDate}）`,
					value: item.priceName
				}))
			})
		},
		toggleColumn(type) {
			this.columns = this.columns.map(col => {
				if (type === 'peo') {
					// peo显示order为1,2,3的列
					col.visible = [1, 2, 3].includes(col.order);
				} else if (type === 'mon') {
					// mon显示order为4,5,6,7的列
					col.visible = [4, 5, 6, 7, 13, 14].includes(col.order);
				} else if (type === 'ele') {
					// ele显示order为8,9,10,11,12的列
					col.visible = [8, 9, 10, 11, 12].includes(col.order);
				}
				return col;
			});
		},
		validateNonZeroNumber(rule, value, callback) {
			// 必须是数值，不能为0，不能为非数字
			if (value === '' || value === null || value === undefined) {
			callback(new Error('请输入补贴额度'));
			} else if (isNaN(value)) {
			callback(new Error('必须为数值'));
			} else if (Number(value) === 0) {
			callback(new Error('不能为0'));
			} else {
			callback();
			}
		},
		resetSearchForm() {
			this.searchForm = {}
			this.getLocationMachineList()
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		getExcelTemplate() {
			var XLSX = require("xlsx");
			let excelData = [
				{regionName: '南区', buildingName: '1栋', roomNo: '101', sexFlag: '男', personCount: '4', quotaName: '学生配额', priceName: '学生配额', deviceNo: '160000001'}
			]
			// 创建一个工作表
			const worksheet = XLSX.utils.json_to_sheet(excelData)
			// 创建一个新的工作簿
			const workbook = XLSX.utils.book_new()

			XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
			// 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
			XLSX.utils.sheet_add_aoa(worksheet, [['区域名称', '楼栋名称', '宿舍号', '性别', '床位数', '配额名称', '单价名称', '电表号']], { origin: 'A1' })
			XLSX.writeFileXLSX(workbook, `宿舍模版.xlsx`)
		},
		importExcel(file) {
			// 接收上传的excel文件，并读取数据，字段名映射如下：
			const _this = this;
			const reader = new FileReader();
			reader.onload = function(e) {
				const data = new Uint8Array(e.target.result);
				const XLSX = require('xlsx');
				const workbook = XLSX.read(data, { type: 'array' });
				const outdata = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
				// 字段映射
				const arr = outdata.map(v => ({
					'regionName': v['区域名称'],
					'buildingName': v['楼栋名称'],
					'roomNo': v['宿舍号'],
					'sexFlag': v['性别'],
					'personCount': v['床位数'],
					'quotaName': v['配额名称'],
					'priceName': v['单价名称'],
					'deviceNo': v['电表号'],
				}));
				console.log(arr);
				if (arr.length) {
					_this.addArray(arr)
				}
				// _this.tabData = arr.concat(_this.tabData)
			};
			reader.readAsArrayBuffer(file);
			return false;
		},
		addArray(arr) {
			importDevice(arr).then(res => {
				res = res.data
				if (res.code == 200) {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
					});
					// 通知更新树形数据
					this.notifyTreeDataUpdate()
				}
			})
		},

		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.delBtlStatu = val.length == 0
		},
		handleSizeChange(val) {
			this.size = val
			this.getLocationMachineList()
		},
		handleCurrentChange(val) {
			this.current = val
			this.getLocationMachineList()
		},
		handleSizeChangeDialog(val) {
			this.dialog.size = val
			this.viewHandle()
		},
		handleCurrentChangeDialog(val) {
			this.dialog.current = val
			this.viewHandle()
		},
		zhuanyi(row) {
			// console.log(row);
			let _that = this
			this.$prompt('请输入新宿舍代表的学号', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				// inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
				// inputErrorMessage: '邮箱格式不正确'
				}).then(({ value }) => {
					if (value) {
						updateJiaofei({
							oldPersonNo: row.personNo,
							newPersonNo: value
						}).then(res => res.data).then(res => {
							// console.log(res);
							if (res.code == 200) {
								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
								})
								_that.viewHandle()
							}
						})
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消转移'
					});
			});
		},
		jieHandle(row) {
			jiebangPeo([{roomId: row.roomId, personId: row.personId}]).then(res => res.data).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
					})
					this.viewHandle()
				}
			})
		},
		faButie(row) {
			this.bu.dialogVisible = true
			this.bu.clilckRow = row
			this.bu.dialogTitle = `发扣补贴（${row.buildingName}-${row.roomNo}）`
			this.bu.editForm = {
				roomId: row.id,
				payQuota: '',
				remark: '',
				lx: 0,
				type: 0
			}
		},
		busubmitForm() {
			const clilckRow = this.bu.clilckRow
			let _that = this
			let obj = JSON.parse(JSON.stringify(this.bu.editForm))
			delete obj.lx
			delete obj.type
			
			// 验证payQuota字段是否为大于0的数字（包括小数）
			const payQuotaRegex = /^[1-9]\d*(\.\d+)?$|^0\.\d+[1-9]\d*$|^0\.[1-9]\d*$/;
			if (!payQuotaRegex.test(obj.payQuota)) {
				this.$message({
					showClose: true,
					message: '补贴额度必须为大于0的数字',
					type: 'error',
				});
				return;
			}
			if (!this.bu.editForm.type) {
				if (!this.bu.editForm.lx) {
					this.$confirm(`确定对(${clilckRow.buildingName}-${clilckRow.roomNo})发放补贴${obj.payQuota}度？`, '发放补贴', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						addButie({...obj, walletId: 1}).then(res => {
							_that.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							});
							_that.buresetForm()
							_that.getLocationMachineList();
						})
					})
				} else {
					this.$confirm(`确定对(${clilckRow.buildingName}-${clilckRow.roomNo})扣除补贴${obj.payQuota}度？`, '扣除补贴', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						delButie({...obj, walletId: 1}).then(res => {
							_that.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							});
							_that.buresetForm()
							_that.getLocationMachineList();
						})
					})
				}
			} else {
				obj.payMoney = obj.payQuota
				delete obj.payQuota	
				if (!this.bu.editForm.lx) {
					this.$confirm(`确定对(${clilckRow.buildingName}-${clilckRow.roomNo})手工充值${obj.payMoney}元？`, '手工充值', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						addYe({...obj, walletId: 2}).then(res => {
							_that.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							});
							_that.buresetForm()
							_that.getLocationMachineList();
						})
					})
				} else {
					this.$confirm(`确定对(${clilckRow.buildingName}-${clilckRow.roomNo})手工扣款${obj.payMoney}元？`, '手工扣款', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						delYe({...obj, walletId: 2}).then(res => {
							_that.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
							});
							_that.buresetForm()
							_that.getLocationMachineList();
						})
					})
				}
			}

		},
		buresetForm(formName) {
			this.$refs.bueditForm.resetFields();
			this.bu.dialogVisible = false
			this.bu.editForm = {}
		},
		buhandleClose() {
			this.buresetForm()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			// this.dialog.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		handleCloseDialog() {
			this.dialog.dialogVisible = false
		},
		locationTreeNodeClick(row) {
			this.total = 0;
			this.size = 10;
			this.current = 1;
			this.clickNode = row;
			this.clearTitle = `确定批量清空'${row.name}'房间配额吗`,
			this.getLocationMachineList();
		},
		getLocationMachineList() {
			this.loading = true;
			getRoomListHis({
				roomId: this.clickNode.id,
				current: this.current,
				size: this.size,
				...this.searchForm
			}).then(res => res.data ).then(res => {
				this.tableData = res.data.records
				this.size = res.data.size
				this.current = res.data.current
				this.total = res.data.total

				this.loading = false;
			}).catch(res => {
				this.loading = false;
			})
		},
		exportList() {
			this.loading = true;
			getRoomListHis({
				roomId: this.clickNode.id,
				current: 1,
				size: 9999,
				...this.searchForm
			}).then(res => res.data ).then(res => {
				// this.tableData = res.data.records
				// this.size = res.data.size
				// this.current = res.data.current
				// this.total = res.data.total
				if (res.data.records.length >  0) {
					let excelData = res.data.records.map((it, index) => ({index: index + 1, id: it.id, ld: it.buildingName, fjmc: `${it.buildingName}-${it.roomNo}`, cws: it.personCount, fjye: it.accBalance, peye: it.quotaBalance }))
					this.getExcel(excelData)
				} else {
					this.$message({
						showClose: true,
						message: '没有可导数据',
						type: 'error',
					});
				}

				this.loading = false;
			}).catch(res => {
				this.loading = false;
			})
		},
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            XLSX.utils.sheet_add_aoa(worksheet, [['序号', '房间id', '楼栋', '房间', '床位数', '房间余额', '配额余额']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `历史房间列表${this.nowDate}.xlsx`)
        },
		viewHandle(command) {
			// this.toggleColumn(rowType)
			// console.log(this.clickNode);
			let row = {}
			let rowType = ''
			if (command) {
				row = command.row
				rowType = command.rowType
			}
			
			let roomId = ""
			let roomNo = ""
			let type = ""
			if (row && row.id && rowType) {
				roomId = row.id
				roomNo = row.roomNo
				type = rowType
				this.dialog.title = (rowType == 'peo' ? '入住人员' : rowType == 'ele' ? '用电明细' : rowType == 'mon' ? '交易记录' : '记录') + `（${row.buildingName}-${row.roomNo}）`
				this.dialog.getParams = {
					roomId: row.id,
					type: rowType,
					roomNo: row.roomNo
				}
				let t = new Date()
				let startDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-01'
				let endDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + t.getDate()
				this.dialog.dateRange = [startDate, endDate]
			} else {
				roomId = this.dialog.getParams.roomId
				roomNo = this.dialog.getParams.roomNo
				type = this.dialog.getParams.type

			}
			this.toggleColumn(type)
			this.dialog.dialogVisible = true


			if (type == 'peo') {
				getPersonList({
					roomId,
					current: this.dialog.current,
					size: this.dialog.size,
				}).then( res=>res.data).then(res => {
					// console.log(res);
					this.dialog.tableData = res.data.records
					this.dialog.total = res.data.total
				})
			} else if (type == 'mon') {
				getMomentList({
					roomId,
					current: this.dialog.current,
					size: this.dialog.size,
					beginDate: this.dialog.dateRange[0],
					endDate: this.dialog.dateRange[1],
				}).then( res=>res.data).then(res => {
					// console.log(res);
					this.dialog.tableData = res.data.records
					this.dialog.total = res.data.total
				})
			} else if (type == 'ele') {
				getDeviceRecord({
					// roomId,
					roomId: this.clickNode.id,
					roomNo: roomNo,
					current: this.dialog.current,
					size: this.dialog.size,
					beginDate: this.dialog.dateRange[0],
					endDate: this.dialog.dateRange[1],
				}).then(res => res.data).then(res => {
					console.log(res);
					
					this.dialog.tableData = res.data.records
					this.dialog.total = res.data.total
				})
			} 
		},
		addHandle(data) {
			//新增楼栋
			this.dialogTitle = `新增楼栋（${data.name}）`
			this.dialogVisible = true
			this.parentObj = data
			this.editForm = {
				locationName: '',
				orderNum: '',
				parentId: data.id
			}
		},
		addRoom(data) {
			//新增房间
			this.dialogTitle = `新增房间（${data.name}）`
			this.dialogVisible = true
			this.dialogType = 'rm'
			this.parentObj = data
			this.editForm = {
				roomNo: '',		// 房间号
				sexFlag: '',	// 性别，0-女；1-男
				personCount: '',	// 床位数
				quotaName: '',	// 配额名称
				priceName: '',	// 单价名称
				buildingId: data.id
			}
		},
		editRoom(row, rowType) {
			console.log(row, rowType);
			
			this.dialogTitle = `编辑房间（${row.buildingName}-${row.roomNo}）`
			this.dialogVisible = true
			this.dialogType = 'rm'
			this.editForm = {
				id: row.id,
				roomNo: row.roomNo,
				sexFlag: String(row.sexFlag),
				personCount: row.personCount,
				quotaName: row.quotaName,
				priceName: row.priceName,
				buildingId: row.buildingId
			}
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.editForm.id) {
						if (this.dialogType == 'ld') {
							updateLd(this.editForm).then(res => {
								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
								});
								this.dialogVisible = false
								this.resetForm(formName)
								// 通知更新树形数据
								this.notifyTreeDataUpdate()
							})
						} else {
							updateRoom(this.editForm).then(res => {
								this.dialogVisible = false
								this.resetForm(formName)
								this.getLocationMachineList()
								// 通知更新树形数据
								this.notifyTreeDataUpdate()
							})
						}
					} else {
						if (this.dialogType == 'ld') {
							addLd(this.editForm).then(res => {
								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
								});
								this.dialogVisible = false
								this.resetForm(formName)
								// 通知更新树形数据
								this.notifyTreeDataUpdate()
							})
						} else {
							addRoom(this.editForm).then(res => {
								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
								});
								this.dialogVisible = false
								this.resetForm(formName)
								// 通知更新树形数据
								this.notifyTreeDataUpdate()
							})
						}
					}
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
		// xinzeng() {
		// 	for (let i = 203; i < 217; i++) {
		// 		addRoom({
		// 			buildingId: 7676,
		// 			personCount: "3",
		// 			roomNo: i,
		// 			sexFlag: 1,
		// 			quotaName: '学生配额',
		// 			priceName: '学生电价',
		// 		}).then(res => {
		// 			this.$message({
		// 				showClose: true,
		// 				message: '操作成功',
		// 				type: 'success',
		// 			});
		// 		})
		// 	}
		// },
		editHandle(data) {
			console.log(data);
			
			this.dialogTitle = `编辑楼栋（${data.name}）`
			this.dialogVisible = true
			this.editForm = {
				id: data.id,
				locationName: data.name,
				orderNum: data.orderNum,
				parentId: data.parentId
			}
		},
		delHandle(data) {
			this.$confirm('确定删除该楼栋吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				delLd(data.id).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
					});
					// 通知更新树形数据
					this.notifyTreeDataUpdate()
				})
			})
		},
		clear_pe() {
			// console.log(this.clickNode);
			let ids = []
			if (this.clickNode.children.length) {
				ids = this.extractLeafIds(this.clickNode.children)
				// console.log(arr);
			} else {
				ids = [this.clickNode.id.toString().replace(this.clickNode.parentId.toString(), '')]
				// console.log(ids);
			}
			// console.log(ids);
			clearPe(ids).then(res => {
				this.$message({
					showClose: true,
					message: '操作成功',
					type: 'success',
				});
				this.locationTreeNodeClick(this.clickNode)
			})
		},
		extractLeafIds(treeData, result = []) {
			for (const node of treeData) {
				// 判断是否存在子节点（兼容空数组或undefined两种情况）
				if (node.children  && node.children.length  > 0) {
					// 递归处理子节点 
					this.extractLeafIds(node.children,  result);
				} else {
					// 收集末端节点id 
					result.push(node.id.toString().replace(node.parentId.toString(), '')); 
				}
			}
			return result;
		}
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}

.icon-container {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
}

.icon-content {
	margin: 15px;
	min-width: 300px;
	/*height: 200px;*/
	text-align: center;

	/*background-color: #3A92F4;*/
	/*color: white;*/
}

.icon-content i {
	font-size: 32px;
}

.icon-success, .icon-error {
	margin: auto;
	width: 15px;
	height: 15px;
	border-radius: 50%;
	transform: translate(-50%, -50%);
	top: 50%;
	left: 50%;
	position: absolute;
}

.icon-success {
	background-color: #6fde4a;
}

.icon-error {
	background-color: #f13434;
}

/* .el-form-item {
	margin-bottom: 0;
} */
</style>